import React, { createContext, useContext } from 'react';

interface HBSidePanelContextProps {
    closeSidePanel: () => void;
}

const HBSidePanelContext = createContext<HBSidePanelContextProps>(null);

export const HBSidePanelProvider: React.FC<HBSidePanelContextProps> = ({
    children,
    closeSidePanel
}) => {
    return (
        <HBSidePanelContext.Provider value={{ closeSidePanel }}>
            {children}
        </HBSidePanelContext.Provider>
    );
};

export const useHBSidePanel = () => {
    const context = useContext(HBSidePanelContext);
    if (!context) {
        throw new Error(
            'useHBSidePanel must be used within a HBSidePanelProvider'
        );
    }
    return context;
};
